// extracted by mini-css-extract-plugin
export default {"nav":"BottomNav_nav__fdu3q","active":"BottomNav_active__zMGRG"};